<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/association/detail/'+association?.id ">chevron_left</mat-icon>
            <h1 class="page-title">{{ association?.providerName }}</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/association'">Associations</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item">{{ association.providerName }}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/association/detail/'+association?.id ">Activities</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">{{ activity.activityType }}</span>
        </div>
    </div>

    <hr class="mb-5" />

    <div class="row mt-4">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Activity Type</h4>
            <div class="label-text">{{activity.activityType}}</div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Credit Value</h4>
            <div class="label-text">{{activity.completionQuestion}}</div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Credit Value</h4>
            <div class="label-text">{{activity.ceuValue}}</div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Unit Base</h4>
            <div class="label-text">{{activity.unitBase}}</div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <div class="table-responsive-dark list-wrapper-bordered-dark">
                <table class="table table-striped table-hover table-borderless ">
                    <thead>
                    <tr>
                        <th class="text-nowrap">Condition Name</th>
                        <th class="text-nowrap">Condition Type</th>
                        <th class="text-nowrap">Operator</th>
                        <th class="text-nowrap">Value If Valid</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngIf="activity?.conditions?.length > 0">
                        <tr *ngFor="let condition of activity?.conditions">
                            <td class="text-start">
                                {{condition.conditionName}}
                            </td>

                            <td class="text-start">
                                {{condition.conditionType}}
                            </td>
                            <td class="text-start">
                                {{condition.integerOperator}}
                            </td>
                            <td class="text-start">
                                {{condition.valueIfValid}}
                            </td>

                        </tr>
                    </ng-container>

                    <tr *ngIf="activity?.conditions?.length == 0">
                        <td colspan="4" class="text-center">
                            <span>No Record</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>


    <div class="row mt-4">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Note</h4>
            <div class="label-text">{{activity.note}}</div>
        </div>
    </div>

    <div class="row my-5">
        <div class="col-12 ">
            <button mat-raised-button (click)="goEdit()" class="edit-button">
               <mat-icon>edit</mat-icon> Edit
            </button>
        </div>
    </div>
</div>

